import { zodResolver } from "@hookform/resolvers/zod";
import { Mail, User2, X } from "lucide-react";
import { useForm } from "react-hook-form";
import { z } from "zod";

import { Button } from "@components/button/button";
import { SpinnerSimple } from "@components/spinner-simple/spinner-simple";

import { editarUsuarioClienteSchema } from "@pages/admin/gerenciar-usuarios-cliente/components/modal-editar-usuario-do-cliente/schema";

import { useAtualizarUsuarioCliente } from "@/hooks/usuários/atualizar-usuario-do-cliente";

import { useStoreZustandUsuarioCliente } from "@/store-zustand/usuarios-do-clientes";

type FormData = z.infer<typeof editarUsuarioClienteSchema>;

type ModalProps = {
  onClose: () => void;
};

export function ModalEditarUsuarioDoCliente({ onClose }: ModalProps) {
  const { usuarioClienteSelecionado } = useStoreZustandUsuarioCliente();
  const { atualizarUsuarioClienteAsync, isLoading } = useAtualizarUsuarioCliente();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormData>({
    resolver: zodResolver(editarUsuarioClienteSchema),
    defaultValues: {
      nome: usuarioClienteSelecionado?.nome,
      email: usuarioClienteSelecionado?.email,
    },
  });

  const onSubmit = async (data: FormData) => {
    if (!usuarioClienteSelecionado?.id) return;

    await atualizarUsuarioClienteAsync({
      user_id: usuarioClienteSelecionado.id,
      payload: {
        nome: data.nome,
        email: data.email,
      },
    });

    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60">
      <div className="relative w-full max-w-xl rounded-lg bg-white p-6 shadow-lg">
        <div className="mb-4 flex items-center justify-between">
          <h2 className="text-xl font-semibold text-zinc-900">Editar usuário</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-800"
            aria-label="Fechar modal"
          >
            <X size={20} />
          </button>
        </div>

        <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
          {/* Nome */}
          <div className="space-y-1">
            <label className="text-sm font-medium text-zinc-700">Nome completo</label>
            <div className="flex h-14 w-full items-center gap-2 rounded-lg border border-zinc-800 px-4">
              <User2 className="text-zinc-400" />
              <input
                {...register("nome")}
                placeholder="Nome usuário"
                className="flex-1 bg-transparent text-lg text-zinc-600 placeholder-zinc-400 outline-none"
              />
            </div>
            {errors.nome && <p className="text-sm text-red-500">{errors.nome.message}</p>}
          </div>

          {/* E-mail */}
          <div className="space-y-1">
            <label className="text-sm font-medium text-zinc-700">E-mail</label>
            <div className="flex h-14 w-full items-center gap-2 rounded-lg border border-zinc-800 px-4">
              <Mail className="text-zinc-400" />
              <input
                {...register("email")}
                placeholder="Informe o E-mail"
                className="flex-1 bg-transparent text-lg text-zinc-600 placeholder-zinc-400 outline-none"
              />
            </div>
            {errors.email && <p className="text-sm text-red-500">{errors.email.message}</p>}
          </div>

          {/* Botões */}
          <div className="mt-4 flex justify-end gap-4 border-t pt-4">
            <Button
              type="button"
              variant="secondary"
              className="px-4"
              onClick={onClose}
              disabled={isLoading}
            >
              Cancelar
            </Button>

            <Button type="submit" className="px-6" disabled={isLoading}>
              {isLoading ? <SpinnerSimple /> : "Salvar alterações"}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}
